import * as React from "react";
import { connect } from "react-redux";
import Loader from "../Generics/Loader";
import { IPilotRouteProps } from "../../redux/modules/router/routes";
import MapLayoutWithTwoSidebars from "../Generics/MapLayoutWithTwoSidebars";
import MapContainerWithUiLayers from "../Generics/MapContainerWithUiLayers";
import ModePilotFlightMarkersLeafletMapContainer from "./ModePilotFlightMarkersLeafletMapContainer";
import MapControlsLayout from "../Generics/MapControlsLayout";
import SidebarVisibilityControl from "./SidebarVisibilityControl";
import GeolocationButton from "../../map/reusableLayers/GeolocationLayer/GeolocationButton";
import SatelliteButtonContainer from "../../map/reusableLayers/WorldLayer/SatelliteButtonContainer";
import OverlaySwitchButton from "../../map/reusableLayers/PrescanLayer/OverlaySwitchButton";
import FitSiteButton from "../Controls/FitSiteButton/FitSiteButton";
import { IGcpAppDispatchProp } from "../../redux/store";
import { getModePilotUiState, IStoreState } from "../../redux/rootReducer";
import SidebarLayout from "../Generics/SidebarLayout";
import ScanDateBar from "../ScanDateBar";
import * as L from "leaflet";
import IconMenuWhite from "./IconMenuWhite";
import FlightMarkersList from "./FlightMarkersList";
import SidebarFooter from "./SidebarFooter";
import { IModePilotUi } from "../../redux/modules/modePilotUi/reducer";
import ShowFlightMarkerLabelsButton from "../Controls/ShowFlightMarkerLabelsButton";
import userTogglesSidebarVisibility from "./scenarios/userTogglesSidebarVisibility";
import userClicksShowFlightMarkerLabelsButton from "./scenarios/userClicksShowFlightMarkerLabelsButton";
import userOpensPilotPage from "./scenarios/userOpensPilotPage";

const FlightMarkersViewPage = () => {
  const isMobile = L.Browser.mobile;

  return (
    <MapLayoutWithTwoSidebars
      left={<FlightMarkersViewPageLeftSidebar />}
      center={
        <MapContainerWithUiLayers
          mapElement={<ModePilotFlightMarkersLeafletMapContainer />}
          uiLayers={[
            <MapControlsLayout
              topLeft={
                <>
                  <SidebarVisibilityControl />
                  {isMobile === false && <FlightMarkerLabelsToggle />}
                </>
              }
              topRight={<GeolocationButton />}
              bottomLeft={
                <>
                  <SatelliteButtonContainer />
                  <OverlaySwitchButton />
                </>
              }
            />,
            <MapControlsLayout
              topCenter={
                <>
                  {isMobile === true && <FlightMarkerLabelsToggle />}
                  <FitSiteButton />
                </>
              }
            />,
          ]}
        />
      }
      right={null}
    />
  );
};

interface IFlightMarkersViewPageLeftSidebarProps extends IGcpAppDispatchProp {
  uiState: IModePilotUi;
}

const FlightMarkersViewPageLeftSidebar = connect((state: IStoreState) => ({
  uiState: getModePilotUiState(state),
}))(({ uiState, dispatch }: IFlightMarkersViewPageLeftSidebarProps) => {
  if (!uiState.sidebarIsVisible) {
    return null;
  }

  return (
    <SidebarLayout
      width={244}
      top={
        <ScanDateBar
          rightIcon={L.Browser.mobile ? <IconMenuWhite /> : null}
          onRightIconClick={() => {
            dispatch(userTogglesSidebarVisibility());
          }}
        />
      }
      center={<FlightMarkersList />}
      bottom={<SidebarFooter />}
    />
  );
});

interface IFlightMarkerLabelsToggleProps extends IGcpAppDispatchProp {
  modePilotUiState: IModePilotUi;
}

const FlightMarkerLabelsToggle = connect((state: IStoreState) => ({
  modePilotUiState: getModePilotUiState(state),
}))(({ modePilotUiState, dispatch }: IFlightMarkerLabelsToggleProps) => {
  return (
    <ShowFlightMarkerLabelsButton
      onClick={() => dispatch(userClicksShowFlightMarkerLabelsButton())}
      isOn={modePilotUiState.showFlightMarkerLabelsIsOn}
    />
  );
});

export default connect()((pilotRouteProps: IPilotRouteProps) => (
  <Loader asyncAction={() => userOpensPilotPage(pilotRouteProps)}>
    {() => <FlightMarkersViewPage />}
  </Loader>
));
